import DPUX from '@elem/compPage/DPUX';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { pathname, theme, sites } from '@elem/compPage/DPUX/config/page';
import { ProductProvider, useProductMsg } from '@elem/compPage/DPUX/ProductProvider';
import { initalState } from '@elem/compPage/DPUX/context/initalState';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

export default function Page({ SEO, pageStatus, countDownEnd, activeTab }: any) {
    const { locale = '' } = useRouter();
    const { t } = useLang('dpux');
    const productMsg = useProductMsg();

    return (
        <PageLayout isNoFixed={true} theme={theme}>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA locale={locale} list={sites} pathname={pathname} />
            <ProductProvider children={<DPUX />} pageStatus={pageStatus} activeTab={activeTab} countDownEnd={countDownEnd} />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale = 'us', query }: GetServerSidePropsContext) {
    if (!sites.includes(locale)) {
        return redirectTo404();
    }
    const _timer = query?._timer ? String(query?._timer) : undefined;
    const tab = query?.tab ? String(query?.tab) : undefined;
    const props = initalState(locale, _timer, tab);
    if (props === '404') {
        return redirectTo404();
    }
    return {
        props,
        // revalidate: 3600 * 24,
    };
}
